import React from "react";
import BottomSheet from "../../BottomSheet";
import Button from "../../Button";

interface ExitSmartScaleConnectionFlowBottomsheetProps {
  show: boolean;
  onExit: () => void;
  onCancel: () => void;
}

const ExitSmartScaleConnectionFlowBottomsheet: React.FC<
  ExitSmartScaleConnectionFlowBottomsheetProps
> = ({ show, onExit, onCancel }) => {
  return (
    <BottomSheet show={show} handleClose={onCancel} zIndex={60}>
      <div className="px-6 pt-2 pb-6">
        <div className="w-10 h-1 rounded-full bg-gray-300 mx-auto mb-4" />
        <h2 className="text-lg font-semibold mb-2">Exit Syncing?</h2>
        <p className="text-[var(--text-secondary)] mb-6">
          If you exit now, pairing will stop and you&apos;ll return to the home
          screen.
        </p>
        <div className="flex gap-3">
          <Button
            onClick={onCancel}
            variant="outlined"
            rounded="full"
            fullWidth
          >
            Stay
          </Button>
          <Button onClick={onExit} variant="contained" rounded="full" fullWidth>
            Exit
          </Button>
        </div>
      </div>
    </BottomSheet>
  );
};

export default ExitSmartScaleConnectionFlowBottomsheet;
